import Component from 'navigation/component/Component'
import './BasicSearch.scss'
export default class BasicSearch extends Component {}
